module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_homon-3f58af7be624ec3e1fe8fb01e133dbdf.png";